import React, {
  useState,
} from 'react';
import {
  Formik,
  Field,
} from 'formik';

import {
  Flex,
} from 'web-styled';
import {
  Modal,
  Button,
  TextField,
  UploadPhoto,
} from 'web-components';

type Props = {
  isOpen: boolean;
  groupName?: string;
  headerText: string;
  groupAvatar: any;
  onSubmit: { (): void };
  onRequestClose: { (): void };
};

const AddGroup = ({
  isOpen,
  groupName = '',
  headerText,
  groupAvatar,
  onSubmit,
  onRequestClose,
}: Props) => {
  const [avatarBinary, setAvatarBinary] = useState('');
  return (
    <Modal
      title={headerText}
      isOpen={isOpen}
      onRequestClose={() => {
        setAvatarBinary('');
        onRequestClose();
      }}
    >
      <Formik
        initialValues={{
          name: groupName,
        }}
        onSubmit={(values, actions) => {
          setAvatarBinary('');
          onSubmit(
            values,
            actions,
            avatarBinary || '',
          );
        }}
      >
        {({
          handleSubmit,
          isSubmitting,
          handleChange,
          values,
        }) => (
          <Flex
            column
            width="100%"
            as="form"
            spacing={15}
            onSubmit={handleSubmit}
          >
            <Flex
              fillSpace
              spacing={30}
            >
              <UploadPhoto
                src={groupAvatar}
                onChange={setAvatarBinary}
              />
              <Field
                autoFocus
                name="name"
                label="Group name"
                value={values.name}
                onChange={handleChange}
                component={TextField}
                autoComplete="off"
                maxLength="128"
                validate={value => !value.length
                  && 'Name is required'}
              />
            </Flex>
            <Flex
              width="100%"
              justify="flex-end"
            >
              <Button
                ghost
                appearance="primary"
                type="submit"
                spacing="large"
                isLoading={isSubmitting}
                isDisabled={isSubmitting}
              >
                Save
              </Button>
            </Flex>
          </Flex>
        )}
      </Formik>
    </Modal>
  );
};

export default AddGroup;
